package com.gsb.vyapar.bhagya.presentation.dialog

sealed class Dialogs {
    data object Loading : Dialogs()
    data object Error : Dialogs()
    data object Success : Dialogs()
    data object Regular : Dialogs()
    data object Login : Dialogs()
    data object Message : Dialogs()
    data object Image : Dialogs()
    data object Pincode : Dialogs()
    data object Location : Dialogs()
    data object AddBusinessPincode : Dialogs()
}